
<template>
  <div></div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  mounted() {
    this.clearLocalStorage();
  },

  computed: {
    ...mapState("user", {
      userInfo: (state) => state.user,
    }),
  },

  methods: {
    ...mapActions({
      user: "user/updateUser",
      profile: "user/updateProfile",
      permissions: "user/updatePermissions",
    }),
    clearLocalStorage() {
      this.user(
        JSON.parse(document.getElementById("user").value).id.toString()
      );
      this.profile(document.getElementById("profile").value.toString());
      let permissions = JSON.parse(
        document.getElementById("permissions").value
      );
      permissions = permissions.map((el) => {
        return el.name;
      });
      this.permissions(permissions);

      //this.$store.commit('setUserInfo', user.id.toString());
      /*localStorage.clear();
      localStorage.setItem("profile", document.getElementById("profile").value);
      localStorage.setItem("user", document.getElementById("user").value);
      let permissions = JSON.parse(
        document.getElementById("permissions").value
      );
      permissions = permissions.map((el) => {
        return el.name;
      });
      localStorage.setItem("permissions", permissions);*/
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/util/HomeAdmClear.vue